<template lang="pug">
  v-row(no-gutters)
    h1(class="new-advert-title") {{ titleName }}
</template>

<script>
export default {
  name: 'Title',
  props: {
    titleName: {
      type: String,
      default: '',
      required: true
    }
  }
}
</script>

<style scoped>
.new-advert-title {
  font-weight: 700;
  font-size: 24px;
  line-height: 33px;
  letter-spacing: -1.25905px;
  color: #000000;
}
</style>
